import Utils from "./Utils";

export class ReportLog {
  constructor(token) {
    this.format = new Format(token);
  }

  add(type, tag, data) {
    this.format.log.push(new Data(type, tag, Utils.toHexString(data)));
  }

  add1(type, code, data) {
    this.format.log.push(new Data(type, code, data));
  }

  add2(rep) {
    for (let i = 0; i < rep.format.log.length; i++) {
      const d = rep.format.log[i];
      this.format.log.push(new Data(d.type, d.code, d.data));
    }
  }

  json() {
    for (let i = 0; i < this.format.log.length; i++) {
      const d = this.format.log[i];
      console.log("To JSON : " + d.type + "/" + d.data);
    }
    const str = JSON.stringify(this.format);
    console.log("FORMATTED TOKEN LOG: " + str);
    return str;
  }
}

export class Format {
  constructor(token) {
    this.log = [];
    if (token != null) {
      this.order_id = token.orderId;
      this.trans_id = token.transId;
    }
  }
}

export class FormatDev {
  constructor(terminalId, btAddr) {
    this.log = [];
    this.bt_addr = btAddr;
    this.terminal_id = terminalId;
  }
}

export class Data {
  constructor(type, code, data) {
    this.time = Math.floor(Date.now() / 1000);
    this.type = type;
    this.data = data;
    this.code = code != null ? code : "";
    console.log(
      "ReportLog: Time:" + this.time + " Type: " + type + " Data:" + data
    );
  }
}
